import React from "react";
import "./About.scss";

const About = () => {
  return (
    <div className="container-fluid login" id="about">
      <form>
        <h1>ABOUT US</h1>
        <p>
          A 2 Z started manufacturing cleaning products in Kollam District,
          Kerala in 2015 and selling them directly to consumers, but as the
          market is very competitive, we decided to shift to network marketing,
          which has more potential for sales and more direct contact with
          consumers, and started network marketing as Springway from 2024 and
          successfully launched our cleaning products. and making sales
        </p>
      </form>

      <form>
        <h1>MISSION & VISION</h1>
        <p>
          Enable anyone to start a business at the lowest possible cost and
          thereby help lift others from poverty to prosperity by sharing
          everything they can to help you and others achieve a happier and more
          fulfilling life
        </p>
      </form>
    </div>
  );
};

export default About;
